import { createSlice } from '@reduxjs/toolkit';

const counterSlice = createSlice({
  name: 'settings',
  initialState: {
    qrPassIntroShown: false,
    // Tutoriales que ya se mostraron solos la primera vez, por slug (ver components/Tutorial)
    tutorialsSeen: {} as Record<string, boolean>,
  },
  reducers: {
    setQrPassIntroShown: (state, action) => {
      state.qrPassIntroShown = action.payload
    },
    setTutorialSeen: (state, action) => {
      state.tutorialsSeen = { ...state.tutorialsSeen, [action.payload]: true }
    },
  },
});

export const { setQrPassIntroShown, setTutorialSeen } = counterSlice.actions;
export default counterSlice.reducer;
